import { useState } from "react";

export const useTermsAgreement = () => {
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsError, setTermsError] = useState("");
  const [hasReadTerms, setHasReadTerms] = useState(false);
  const [pendingProceedToPayment, setPendingProceedToPayment] = useState(false);

  const handleTermsAgreementChange = (checked) => {
    setAgreedToTerms(checked);
    if (checked && hasReadTerms) {
      setTermsError("");
    }
  };

  const handleTermsOpen = (event) => {
    event.preventDefault();
    setPendingProceedToPayment(false);
    setShowTermsModal(true);
  };

  return {
    agreedToTerms,
    setAgreedToTerms,
    showTermsModal,
    setShowTermsModal,
    termsError,
    setTermsError,
    hasReadTerms,
    setHasReadTerms,
    pendingProceedToPayment,
    setPendingProceedToPayment,
    handleTermsAgreementChange,
    handleTermsOpen,
  };
};
